import Phaser from 'phaser';

export const MINIMUM_TOUCH_TARGET = 44;

/** Expands a text control's invisible hit area without changing its visual bounds. */
export function ensureMinimumTextTouchTarget<T extends Phaser.GameObjects.Text>(
  target: T,
  minimumSize = MINIMUM_TOUCH_TARGET,
): T {
  const hitWidth = Math.max(minimumSize, target.width);
  const hitHeight = Math.max(minimumSize, target.height);
  target.setInteractive({
    hitArea: new Phaser.Geom.Rectangle(
      (target.width - hitWidth) / 2,
      (target.height - hitHeight) / 2,
      hitWidth,
      hitHeight,
    ),
    hitAreaCallback: Phaser.Geom.Rectangle.Contains,
    useHandCursor: true,
  });
  return target;
}
